/**
 * DateRangePicker Molecule Component
 * Selects pickup and return dates for car rental
 */

'use client'

import { DateInput } from '@/components/molecules/DateInput'
import { cn } from '@/lib/utils'
import { isBefore, isSameDay, startOfDay } from 'date-fns'

interface DateRangePickerProps {
	pickupDate: Date | undefined
	returnDate: Date | undefined
	onPickupDateChange: (date: Date | undefined) => void
	onReturnDateChange: (date: Date | undefined) => void
	className?: string
}

export function DateRangePicker({
	pickupDate,
	returnDate,
	onPickupDateChange,
	onReturnDateChange,
	className,
}: DateRangePickerProps) {
	const today = startOfDay(new Date())

	return (
		<div className={cn('grid grid-cols-1 md:grid-cols-2 gap-4', className)}>
			<DateInput
				label='Fecha de Recogida'
				value={pickupDate}
				onChange={onPickupDateChange}
				disabledDates={date => isBefore(date, today)}
			/>

			<DateInput
				label='Fecha de Devolución'
				value={returnDate}
				onChange={onReturnDateChange}
				disabled={!pickupDate}
				disabledDates={date => {
					if (!pickupDate) return true
					return (
						isBefore(date, today) ||
						isBefore(date, pickupDate) ||
						isSameDay(date, pickupDate)
					)
				}}
			/>
		</div>
	)
}
